const KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  ADMIN_CODE: 'adminCode',
  ADMIN_NAME: 'adminName',
  ADMIN_TYPE: 'adminType',
  BRANCH_CODE: 'branchCode',
}

export function saveTokens({ accessToken, refreshToken, adminCode, adminName, adminType, branchCode }) {
  localStorage.setItem(KEYS.ACCESS_TOKEN, accessToken)
  localStorage.setItem(KEYS.REFRESH_TOKEN, refreshToken)
  if (adminCode) localStorage.setItem(KEYS.ADMIN_CODE, adminCode)
  if (adminName) localStorage.setItem(KEYS.ADMIN_NAME, adminName)
  if (adminType) localStorage.setItem(KEYS.ADMIN_TYPE, adminType)
  if (branchCode) localStorage.setItem(KEYS.BRANCH_CODE, branchCode)
}

export function clearTokens() {
  Object.values(KEYS).forEach(key => localStorage.removeItem(key))
}

export function getAccessToken() {
  return localStorage.getItem(KEYS.ACCESS_TOKEN)
}

export function getRefreshToken() {
  return localStorage.getItem(KEYS.REFRESH_TOKEN)
}

/**
 * JWT 의 exp(만료 시각)를 ms 로 읽는다. 못 읽으면 null.
 * 서명은 서버만 확인할 수 있어 여기서는 만료만 본다.
 */
function readExpMs(token) {
  try {
    const b64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const { exp } = JSON.parse(atob(b64 + '='.repeat((4 - (b64.length % 4)) % 4)))
    return typeof exp === 'number' ? exp * 1000 : null
  } catch {
    return null
  }
}

/** 토큰이 있고 exp 가 안 지났나. exp 를 못 읽으면 서버에 맡긴다 - 토큰 형식이 바뀌어도 로그인 직후 되돌아오는 고리가 생기지 않게 */
function isAlive(token) {
  if (!token) return false
  const expMs = readExpMs(token)
  return expMs === null || expMs > Date.now()
}

/**
 * 화면을 열어도 되는 토큰이 있나 - 접근 토큰이 살아 있거나, 그게 지났어도 갱신 토큰이 살아 있다.
 * 접근 토큰만 지났으면 첫 API 가 401 을 받고 갱신해 다시 부른다(api/index.js).
 * 둘 다 지났으면 화면을 그리기 전에 로그인으로 보낸다 - 그전에는 있기만 하면 통과라 만료된 토큰으로도
 * 대시보드가 그려진 뒤 첫 API 가 거절당해 '로그인이 만료되었습니다' 모달이 떴다(2026-11-02).
 * 서명 키가 바뀐 토큰은 exp 가 남아 있어도 서버가 거절한다 - 그건 첫 API 응답에서 거른다.
 */
export function isLoggedIn() {
  return isAlive(getAccessToken()) || isAlive(getRefreshToken())
}

export function getAdminInfo() {
  return {
    adminCode: localStorage.getItem(KEYS.ADMIN_CODE),
    adminName: localStorage.getItem(KEYS.ADMIN_NAME),
    adminType: localStorage.getItem(KEYS.ADMIN_TYPE),
    branchCode: localStorage.getItem(KEYS.BRANCH_CODE),
  }
}
